module.exports = __webpack_public_path__ + "public/img/subscription-bg-3-9b2c7581.jpg";